module.exports = __webpack_public_path__ + "img/arrow-right.c766199a.svg";